type ProfileEnableDisableModalProps = {
  profileName: string;
  action: "enable" | "disable";
};

export function ProfileEnableDisableModal({
  profileName,
  action,
}: ProfileEnableDisableModalProps) {
  const actionLabel = action === "enable" ? "Enable" : "Disable";

  return (
    <div className="profile-enable-disable">
      <p>
        Are you sure, you want to{" "}
        <span style={{ color: "#a93a37", fontWeight: 700 }}>
          {actionLabel} Profile
        </span>
        ?
      </p>
    </div>
  );
}
